// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"FooterBreadcrumbs_listContainer__P2kxZ","breadcrumbs":"FooterBreadcrumbs_breadcrumbs__k5h1G","logo":"FooterBreadcrumbs_logo__8dI01"};